import { Component } from '@angular/core';
import { NxHeadlineModule } from '@allianz/ng-aquila/headline';
import { NxCopytextModule } from '@allianz/ng-aquila/copytext';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-legal-notice',
  imports: [
    NxHeadlineModule,
    NxCopytextModule,
    TranslocoPipe,
  ],
  templateUrl: './legal-notice.component.html',
  styleUrl: './legal-notice.component.scss'
})
export class LegalNoticeComponent {

}
